module.exports = __webpack_public_path__ + "media/images/flags/64/Macau-41acf22ff63d21e741c8981448a2695a.png";